import Fuse from "fuse.js";
import { useMemo } from "react";
import type { Entry } from "../normalize";
import { FUSE_OPTIONS } from "./fuseConfig";

export function useFuseSearch(
	data: Entry[],
	query: string,
): Set<string> | null {
	const trimmed = query.trim();
	const hasQuery = trimmed.length > 0;

	// Build Fuse lazily — only when the user has typed something. On a fresh
	// /entries mount with no search query, this saves the index pass entirely.
	// Once Fuse exists, keystroke changes don't rebuild it (the dep is the
	// boolean `hasQuery`, not `trimmed`); only `data` changes (cache refetch)
	// trigger a rebuild.
	const fuse = useMemo(
		() => (hasQuery ? new Fuse(data, FUSE_OPTIONS) : null),
		[data, hasQuery],
	);

	return useMemo(() => {
		if (!fuse || !trimmed) return null;
		return new Set(fuse.search(trimmed).map((r) => r.item.id));
	}, [fuse, trimmed]);
}
